import React from 'react';
import { useNavigate } from 'react-router-dom';

const ReferralTerms = () => {
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: '800px', margin: '40px auto', padding: '0 20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
      <button
        onClick={() => navigate(-1)}
        style={{
          padding: '8px 16px',
          backgroundColor: '#95a5a6',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          marginRight: '15px',
          marginBottom: '20px',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        ← Back
      </button>
      <h1 style={{ textAlign: 'center', marginBottom: '30px', color: '#333' }}>Pulc AI Limited – Referral Competition Terms and Conditions</h1>

      <section style={{ marginBottom: '20px' }}>
        <h2 style={{ color: '#555', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>Eligibility</h2>
        <p>The competition is open exclusively to secondary school students who are residents of the Republic of Ireland.</p>
      </section>

      <section style={{ marginBottom: '20px' }}>
        <h2 style={{ color: '#555', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>Competition Entry</h2>
        <ol style={{ paddingLeft: '20px' }}>
          <li>To enter the competition, participants must successfully refer a friend to register on www.pulc.ai by having their friend enter the participant's valid email address upon registration.</li>
          <li>Participants can refer more than one individual. Each valid referral will count as an additional entry into the competition.</li>
          <li>Each referred individual must register with the referer's referral code, found in "My Account".</li>
          <li>Each referred individual must log into their Pulc account on at least three separate calendar days within the designated competition period.</li>
          <li>Each login must include the submission of an original and distinct essay or Maths answer. Duplicate or previously submitted material will invalidate the entry.</li>
        </ol>
      </section>

      <section style={{ marginBottom: '20px' }}>
        <h2 style={{ color: '#555', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>Restrictions</h2>
        <ul style={{ paddingLeft: '20px', listStyleType: 'disc' }}>
          <li>Participants must not create multiple or fraudulent accounts. Pulc AI Limited reserves the right to disqualify any entries suspected of violating this rule.</li>
          <li>All referrals and submissions are subject to verification by Pulc AI Limited.</li>
        </ul>
      </section>

      <section style={{ marginBottom: '20px' }}>
        <h2 style={{ color: '#555', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>Prize</h2>
        <ul style={{ paddingLeft: '20px', listStyleType: 'disc' }}>
          <li>The prize consists of three (3) €25 Amazon vouchers, each awarded to a different winner.</li>
          <li>Each valid referral qualifies as one entry into the competition.</li>
          <li>The winner will be selected randomly from all valid entries.</li>
        </ul>
      </section>

      <section style={{ marginBottom: '20px' }}>
        <h2 style={{ color: '#555', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>Competition Period</h2>
        <p>The competition opens immediately and closes at 23:59 (Irish Standard Time) on Thursday, 8th May.</p>
      </section>

      <section style={{ marginBottom: '20px' }}>
        <h2 style={{ color: '#555', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>Winner Notification</h2>
        <ul style={{ paddingLeft: '20px', listStyleType: 'disc' }}>
          <li>The winner will be notified via email and announced on Friday, 9th May.</li>
          <li>Pulc AI Limited's decision is final, and no correspondence regarding the result will be entered into.</li>
        </ul>
      </section>

      <section style={{ marginBottom: '20px' }}>
        <h2 style={{ color: '#555', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>General Terms</h2>
        <ul style={{ paddingLeft: '20px', listStyleType: 'disc' }}>
          <li>Pulc AI Limited reserves the right to amend these terms and conditions or to withdraw the competition at any time without notice.</li>
          <li>By entering the competition, participants agree to these terms and conditions and consent to their details being used by Pulc AI Limited solely for the purposes of administering this competition.</li>
        </ul>
      </section>
    </div>
  );
};

export default ReferralTerms; 